import { convertToParens, printNumber, yearRange } from "src/utils";
import Input from "../Inputs/Input";
import { useState } from "react";
import { RATE } from "./EquivalentYieldCalculator";

interface SafeWDCalculatorProps {
  calc: any;
  setCalcField?: (field: string) => (value: any) => void;
  showInputs?: boolean;
}

const SafeWDCalculator = ({
  calc,
  setCalcField,
  showInputs = true,
}: SafeWDCalculatorProps) => {
  const [selectedCol, setSelectedCol] = useState<string | null>(null);
  const [selectedRow, setSelectedRow] = useState<number | null>(null);

  const handleSetField = (field: string) => (value: any) => {
    if (setCalcField) {
      setCalcField(field)(value);
    }
  };

  const income = calc.income || 0;

  return (
    <div className="border p-4 rounded-lg bg-white shadow-md print:shadow-none">
      <div className="flex justify-between gap-5">
        {showInputs && (
          <div className="flex justify-center items-center w-[600px]">
            <div className="flex flex-col gap-2 w-72">
              <Input
                value={calc.initialPremium}
                subtype="money"
                label="Initial Premium"
                setValue={handleSetField("initialPremium")}
              />
              <Input
                value={calc.yearsOfDeferral}
                subtype="number"
                label="Years of Deferral"
                setValue={handleSetField("yearsOfDeferral")}
              />
              <Input
                value={calc.income}
                subtype="money"
                label="Income"
                setValue={handleSetField("income")}
              />
            </div>
          </div>
        )}
        <div>
          <table className="w-full border text-center">
            <thead
              className={`text-sm cursor-pointer text-left sticky z-50 border font-normal!`}
            >
              <tr className="text-lg">
                <th
                  className={`border px-6 py-3 font-medium text-center ${selectedCol === "income" ? "bg-slate-200" : ""}`}
                  onClick={() =>
                    selectedCol === "income"
                      ? setSelectedCol(null)
                      : setSelectedCol("income")
                  }
                >
                  To get an <br /> income of:
                </th>
                <th
                  className={`border px-6 py-3 font-medium text-center ${selectedCol === "rate" ? "bg-slate-200" : ""}`}
                  onClick={() =>
                    selectedCol === "rate"
                      ? setSelectedCol(null)
                      : setSelectedCol("rate")
                  }
                >
                  At a <br /> withdrawal rate of:
                </th>
                <th
                  className={`border px-6 py-3 font-medium text-center ${selectedCol === "balance" ? "bg-slate-200" : ""}`}
                  onClick={() =>
                    selectedCol === "balance"
                      ? setSelectedCol(null)
                      : setSelectedCol("balance")
                  }
                >
                  I need a <br /> balance of:
                </th>
                <th
                  className={`border px-6 py-3 font-medium text-center ${selectedCol === "return" ? "bg-slate-200" : ""}`}
                  onClick={() =>
                    selectedCol === "return"
                      ? setSelectedCol(null)
                      : setSelectedCol("return")
                  }
                >
                  Which requires a <br /> rate of return of:
                </th>
              </tr>
            </thead>
            <tbody className="inconsolata border text-center ">
              {yearRange(1, 6).map((w, index) => {
                const rate = RATE(
                  calc.yearsOfDeferral,
                  0,
                  -calc.initialPremium,
                  income / (w / 100),
                  undefined,
                );
                const isRowSelected = selectedRow === index;
                return (
                  <tr
                    className={`border ${isRowSelected ? "bg-slate-200" : ""}`}
                    key={index}
                    onClick={() =>
                      setSelectedRow(selectedRow === index ? null : index)
                    }
                  >
                    <td
                      className={`border px-2 py-2 ${selectedCol === "income" ? "bg-slate-200" : ""} ${isRowSelected && selectedCol === "income" ? "bg-slate-300!" : ""}`}
                    >
                      {printNumber(income)}
                    </td>
                    <td
                      className={`border px-2 py-2 ${selectedCol === "rate" ? "bg-slate-200" : ""} ${isRowSelected && selectedCol === "rate" ? "bg-slate-300!" : ""}`}
                    >
                      {`${w}%`}
                    </td>
                    <td
                      className={`border px-2 py-2 ${selectedCol === "balance" ? "bg-slate-200" : ""} ${isRowSelected && selectedCol === "balance" ? "bg-slate-300!" : ""}`}
                    >
                      {printNumber(income / (w / 100))}
                    </td>
                    <td
                      className={`border px-2 py-2 ${selectedCol === "return" ? "bg-slate-200" : ""} ${isRowSelected && selectedCol === "return" ? "bg-slate-300!" : ""} ${rate < 0 ? "text-red-600" : ""}`}
                    >
                      {convertToParens(`${rate}%`)}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default SafeWDCalculator;
